import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { StorageService } from './storage.service';
import { Individual } from '../../proxy/models/common';

@Injectable({
  providedIn: 'root'
})
export class IndividualService {
  private readonly storageKey = 'avalonSurveysIndividual';
  private firstNameSubject = new BehaviorSubject('');
  private lastNameSubject = new BehaviorSubject('');

  constructor(
    private storageService: StorageService
  ) {}

  public saveIndividual(user: Individual): void {
    this.storageService.saveData(this.storageKey, JSON.stringify(user));
    this.setUserNameSubj(user?.FirstName);
    this.setUserLastNameSubj(user?.LastName);
  }

  public getIndividual(): Individual | null {
    const user = this.storageService.getData(this.storageKey);
    return (user && JSON.parse(user)) || null;
  }

  public setUserNameSubj(value: string): void {
    this.firstNameSubject.next(value);
  }

  public setUserLastNameSubj(value: string): void {
    this.lastNameSubject.next(value);
  }

  public get firstName(): Observable<string> {
    return this.firstNameSubject.asObservable();
  }

  public get lastName(): Observable<string> {
    return this.lastNameSubject.asObservable();
  }

  public removeIndividual(): void {
    this.storageService.removeData(this.storageKey);
    this.firstNameSubject.next('');
    this.lastNameSubject.next('');
  }
}
